import { Header, type IHeaderProps } from '@procurify/ui'

export type ConversationTextVariant = NonNullable<IHeaderProps['as']>

export interface IConversationTextProps {
  variant: ConversationTextVariant
  content: string
}

export const ConversationText = ({
  variant,
  content,
}: IConversationTextProps) => <Header as={variant}>{content}</Header>
